import script from "./OtpInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtpInput.vue?vue&type=script&lang=ts&setup=true"

import "./OtpInput.vue?vue&type=style&index=0&id=779aefc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779aefc8"]])

export default __exports__